import { Component, OnInit } from '@angular/core';
import { BaseComponent } from '../base/base.component';

//config
import { environment } from './../../../environments/environment';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  styleUrls: ['./error.component.scss']
})
export class ErrorComponent extends BaseComponent implements OnInit {

  ngOnInit(): void {
  	super.ngOnInit();
  	var router = this.router;
  	var localSession = this.localSession;

    var pid = setInterval(function(){
	  if (localSession.isSocketConnected()) {
	    router.navigate(['/IdleStateComponent']);
	    clearInterval(pid);
	  }
	}, environment.socketIO.timeout);
  }

}
